<modal
  [id]="id"
  [header]="headerText"
  [closeButtonEnabled]="!isSubmitting()"
  [showHeaderDivider]="true"
  [showFooterDivider]="false"
  [heightClass]="'tw-h-auto'"
  [enableBackdropClose]="!isSubmitting()"
  [escapeToClose]="!isSubmitting()"
  (onCloseModal)="handleModalClose()"
  [headerIcon]="plusIcon"
>
  <div slot="body">
    <basic-input
      [control]="personaName"
      [label]="'Persona name'"
      [placeholder]="'Persona name'"
      [autofocus]="true"
      (onKeydown)="onNameKeydown($event)"
    ></basic-input>
  </div>
  <div class="tw-flex tw-justify-center tw-items-center tw-gap-2 tw-px-6 tw-pb-6" slot="footer">
    <button
      type="button"
      class="tw-flex tw-items-center tw-justify-center tw-gap-2 tw-w-full tw-text-white tw-bg-blue-600 hover:tw-bg-blue-700 disabled:tw-opacity-60 disabled:tw-pointer-events-none tw-font-medium tw-rounded-xl tw-text-sm tw-px-5 tw-py-3 tw-transition-colors"
      [disabled]="isSubmitting()"
      (click)="onContinue()"
    >
      @if (isSubmitting()) {
        <progress-circle [isInfinite]="true" class="tw-inline-flex tw-scale-75" colorClasses="tw-border-white tw-border-r-blue-200"></progress-circle>
      }
      {{ submitButtonText }}
    </button>
  </div>
</modal>
